module.exports = { "default": require("core-js/library/fn/number/parse-float"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/~/babel-runtime/core-js/number/parse-float.js
// module id = 707
// module chunks = 0